module.exports = __webpack_public_path__ + "img/ssl-secure.2b1d1386.png";